function stringifyNamePhone(entry) {
    return `${entry.name} - ${entry.phone}`;
}

export {
    stringifyNamePhone,
    stringifyNamePhone as stringifyNamePhoneFidelity,
}